export class ChunkUploader {
    static get TAMANHO_CHUNK() {
        // Primeiro tenta runtime config, depois build-time, depois fallback
        const runtimeConfig = window.ENV_CONFIG?.CHUNK_SIZE;
        const buildTimeConfig = process.env.VUE_APP_LANDING_PAGE_CHUNK_SIZE;
        return parseInt(runtimeConfig || buildTimeConfig) || 500000;
    }

    static precisaDividir(data) {
        try {
            const jsonString = JSON.stringify(data);
            return jsonString.length > this.TAMANHO_CHUNK;
        } catch {
            return false;
        }
    }

    static dividirEmChunks(landingPage) {
        if (!landingPage.children || landingPage.children.length === 0) {
            return [landingPage];
        }

        const chunks = [];
        const baseSize = JSON.stringify({
            ...landingPage,
            children: [],
        }).length;

        let currentChunk = {
            ...landingPage,
            children: [],
            isChunk: true,
            chunkIndex: 0,
            totalChunks: 1,
        };

        let currentSize = baseSize;

        for (const child of landingPage.children) {
            const childSize = JSON.stringify(child).length;

            if (currentSize + childSize > this.TAMANHO_CHUNK && currentChunk.children.length > 0) {
                chunks.push({ ...currentChunk });
                currentChunk = {
                    ...landingPage,
                    children: [child],
                    isChunk: true,
                    chunkIndex: chunks.length,
                    totalChunks: 1,
                };
                currentSize = baseSize + childSize;
            } else {
                currentChunk.children.push(child);
                currentSize += childSize;
            }
        }

        if (currentChunk.children.length > 0) {
            chunks.push(currentChunk);
        }

        // Atualiza o total de chunks
        chunks.forEach((chunk, index) => {
            chunk.chunkIndex = index;
            chunk.totalChunks = chunks.length;
        });

        return chunks;
    }

    static async enviarEmChunks(landingPage, enviarFuncao) {
        if (!this.precisaDividir(landingPage)) {
            const response = await enviarFuncao(landingPage);

            if (!response.success) {
                const error = new Error(`Erro ao enviar landing page`);
                error.response = {
                    data: {
                        errors: response.errors,
                    },
                };
                throw error;
            }

            return response;
        }

        const chunks = this.dividirEmChunks(landingPage);
        console.log(`Enviando landing page em ${chunks.length} chunks`);

        let ultimaResposta;

        for (const chunk of chunks) {
            console.log(`Enviando chunk ${chunk.chunkIndex + 1}/${chunk.totalChunks}`);

            const response = await enviarFuncao(chunk);

            if (!response.success) {
                const error = new Error(`Erro no chunk ${chunk.chunkIndex + 1}`);
                error.response = {
                    data: {
                        errors: response.errors,
                    },
                };
                throw error;
            }

            ultimaResposta = response;
        }

        return ultimaResposta;
    }
}
